export default __webpack_public_path__ + "static/media/clock.3ac353b1.svg";